import React from 'react';
import styled from 'styled-components';
import { Flex, Heading, Text, Button } from 'rebass';
import Link from 'components/Link';
import colors from 'theme/colors';

const Wrapper = styled(Flex)`
  border: 1px solid ${colors.primary};
  max-width: calc(50% - 15px);
  @media screen and (max-width: 1024px) {
    margin-bottom: 40px;
    max-width: 100%;
    justify-content: center;
  }
`;

const ContentWrapper = styled(Flex)`
  max-width: 450px;
  @media screen and (max-width: 1024px) {
    max-width: 100%;
  }
`;

const RoleInfo = styled(Text)`
  white-space: pre-wrap;
  line-height: 1.5;
`;
interface SignUpRoleDescriptionProps {
  userRole: string;
  userRoleTitle: string;
  userRoleInfo: string;
}

const SignUpRoleDescription: React.FC<SignUpRoleDescriptionProps> = (props): JSX.Element => {
  const { userRole, userRoleTitle, userRoleInfo } = props;
  return (
    <Wrapper width="100%" p={[2, 4, 6]}>
      <ContentWrapper flexDirection="column" alignItems="center">
        <Heading as="h3" fontSize={8} fontWeight={6} mb={5}>
          {userRoleTitle}
        </Heading>
        <RoleInfo as="p" fontSize={[2, 2, 4]} fontWeight={5} mb={6}>
          {userRoleInfo}
        </RoleInfo>
        <Link to={`${userRole.toLowerCase()}/signup`}>
          <Button variant="primary">Sign Up</Button>
        </Link>
      </ContentWrapper>
    </Wrapper>
  );
};

export default SignUpRoleDescription;
